export default __webpack_public_path__ + "b9cbfae98ce5551be1cf6959a5b54479.png";